import React from 'react';

export const useBool = (defaultValue?: boolean) => {
    return React.useState<boolean>(defaultValue ?? false);
};
